module.exports = __webpack_public_path__ + "img/img5.41801087.png";